module.exports = __webpack_public_path__ + "img/ico-persons.2d8eb951.svg";